import { render, staticRenderFns } from "./VendorsList.vue?vue&type=template&id=410ed5e4"
import script from "./VendorsList.vue?vue&type=script&lang=js"
export * from "./VendorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports